<template>
    <!--srcviewsproductstoreproductpartBasicvuehtmlStart-->

    <div id="defaultId1" class=" defBord  ">
        <!-- 作者：luoyiming
    	时间：2019-10-26
    	描述：菜品管理-菜品编辑-基础信息 -->
        <div id="idS6Or37" class="basic-setting-content pl16 pr16 defBord  ">
            <!-- 基本信息 -->
            <div id="idxp6Uuf" class="common-form defBord  ">{{ $t('基本信息') }}
            </div>
            <el-form-item id="idzkvfE9" class=" defBord  " :label="$t('菜品名称')"
                :rules="[{ required: true, message: $t('请填写菜品名称') }]" prop="model.product_name">
                <el-input id="idbtWfmq" v-model="form.model.product_name" class="max-w460 defBord  "
                    @blur="validateProductName"></el-input>
                <el-button id="id8EApwh" @click="onDishInformation" class=" defBord   " size="small" type="primary"
                    :loading="loading">{{ $t('AI魔法创建') }}
                </el-button>
            </el-form-item>
            <el-form-item id="idAh9Iml" class=" defBord  " :label="$t('所属分类')"
                :rules="[{ required: true, message: $t('你选择菜品分类') }]" prop="model.category_id">
                <el-select id="idxKUFLs" v-model="form.model.category_id" class=" defBord  ">
                    <template id="idXiPBpN" class=" defBord  ">
                        <el-option id="idvmznbG" v-for="cat in categoryList" class="defBord" :value="cat.category_id"
                            :key="cat.category_id" :label="cat.name">
                        </el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item id="idS72c22" class=" defBord  " :label="$t('菜品图片')"
                :rules="[{ required: true, message: $t('请上传菜品图片') }]" prop="model.image">
                <div id="idiPluZZ" class=" defBord  draggable-list">
                    <draggable id="idPgAStv" v-model="form.model.image" class="wrapper defBord  ">
                        <transition-group id="idwaJ1hv" class=" defBord  ">
                            <div id="idEEgtiU" v-for="(item, index) in form.model.image" class="item defBord  "
                                :key="item.file_path">
                                <img id="idmeqXpt" class=" defBord  " v-img-url="item.file_path" />
                                <a id="idVz62TL" class="delete-btn defBord  " href="javascript:void(0);"
                                    @click.stop="deleteImg(index)">
                                    <i id="idFiHtz5" class="el-icon-close defBord  ">
                                    </i>
                                </a>
                            </div>
                        </transition-group>
                    </draggable>
                    <div id="idvLvvBh" @click="openProductUpload" class="item img-select defBord  ">
                        <i id="idITqWx2" class="el-icon-plus defBord  ">
                        </i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item id="idSnR1SF" class=" defBord  " :label="$t('菜品卖点')">
                <el-input id="idIwd29F" v-model="form.model.selling_point" class="max-w460 defBord  " type="textarea">
                </el-input>
                <el-button id="id8EApwh" @click="onSellingPoint" size="small" type="primary"
                    :loading="selling_point_loading">{{ $t('换一换') }}
                </el-button>
            </el-form-item>
            <!-- 菜品图片组件 -->
            <Upload id="idVRrwe8" class=" defBord  " v-if="isProductUpload" :config="{ total: 9 }"
                :isupload="isProductUpload" :isAspectRatio="false" @returnImgs="returnProductImgsFunc">{{ $t('上传图片') }}
            </Upload>
            <el-form-item id="c794d1" class=" uEXwDSa           " :label="$t('配料')"
                :rules="[{ required: true, message: '' }]" prop>
                <div id="idhhQjkh">
                    <el-button id="id8sjR97" @click="addItem">{{ $t('添加项') }}
                    </el-button>
                    <el-button id="idjvA9Wx" @click="removeItem">{{ $t('删除项') }}
                    </el-button>
                    <el-row id="idfszXiq">
                        <template v-for="item in form.model.ingredient">
                            <el-col id="idfqh68V" v-if="form.model.ingredient.length" class="uiNJkJ4" :span="6"
                                :key="item.id">
                                <el-input id="idGiAMPz" v-model="item.ingredient_name" class="uBgpnls uBuIHG1"
                                    :disabled="item.ingredient_id > 0 ? true : false">
                                </el-input>
                                <el-button id="idOSzPuv" @click="deleteItem(item.ingredient_name)" class="   uFZHTog"
                                    icon="el-icon-close">
                                </el-button>
                            </el-col>
                        </template>
                    </el-row>
                </div>
            </el-form-item>
        </div>
    </div>
    <!--srcviewsproductstoreproductpartBasicvuehtmlEnd-->
</template>

<script>
// interfaceCode
//importStart

//importEnd
import PorductApi from '@/api/product.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
export default {
    components: {
        Upload,
        draggable
    },
    data() {
        return {
            // insertData
            // srcviewsproductstoreproductpartBasicvueDataStart

            // formData
            formData: {},
            // isProductUpload
            isProductUpload: false,
            // srcviewsproductstoreproductpartBasicvueDataEnd
            // 分类下拉
            categoryList: []
        };
    },
    props: ['activeName'],
    inject: ['form'],
    watch: {
        'activeName': {
            handler() {
                this.categoryLabel()
            },
        },
        'formData.category': {
            handler() {
                this.categoryLabel()
            },
            deep: true
        }
    },
    created() {
        this.$set(this, 'formData', this.form);
    },
    methods: {
        // 菜品名称非空校验
        validateProductName() {
            if (!this.form.model.product_name) {
                return
            }
            const param = {
                product_name: this.form.model.product_name,
                product_type: 1
            }
            PorductApi.validate_product_name(param, true).then(res => {
                if (res.code === 1 && res.msg === '该菜品已存在') {
                    this.$message.warning(res.msg)
                    this.form.model.product_name = ''
                }
            })
        },
        // 所属分类展示
        categoryLabel() {
            this.categoryList = this.formData.category.map(item => {
                let category, name;
                if (item.lang && item.lang.category) {
                    category = JSON.parse(item.lang.category)
                }
                if (category) {
                    const key = this.activeName
                    name = category[key] || item.name
                } else {
                    name = item.name
                }
                return {
                    category_id: item.category_id,
                    name: name
                }
            })
        },
        // insertMethod
        // srcviewsproductstoreproductpartBasicvueMethodStart
        // onDishInformation
        onDishInformation() {
            let self = this;

            if (self.form.model.product_name.length == 0) {
                this.$message({
                    type: 'info',
                    message: this.$t('请输入菜品名称！')
                });
                return;
            }


            self.loading = true;

            PorductApi.dishInformation(self.form.model.product_name, {}, true).then(res => {
                self.loading = false;
                console.log(res.info);
                const params = JSON.parse(res.data.response)

                //基本信息
                //所属分类
                for (let item of this.formData.category) {
                    // 在这里对每个选项执行需要的操作
                    if (item.name == params.tasted) {
                        self.form.model.category_id = item.category_id; //所属分类
                        console.log("所属分类" + item.category_id);
                        break;
                    }
                    // console.log(item);
                }
                //介绍
                if (self.form.model.selling_point.length == 0) {
                    self.form.model.selling_point = params.feature;
                }

                //菜品配料
                // this.form.model.ingredient = params.ingredients
                console.log("params.ingredients", params.ingredients);
                if (Array.isArray(params.ingredients) && params.ingredients.length > 0) {
                    // console.log("params.ingredients true");
                    for (let item of params.ingredients) {

                        console.log("params.ingredients item", item);

                        this.form.model.ingredient.push({
                            ingredient_name: item,
                            sort: 1,
                        });
                    }
                }

                //规格库存
                self.form.model.deduct_stock_type = 10; //扣减库存方式 "10">下单减库存 20">付款减库存
                self.form.model.product_unit = "份" //菜品单位
                self.form.model.spec_type = 10;
                // self.form.model.product_price = ""; //菜品价格

                // self.form.model.sku[0].product_price = "1";
                // self.form.model.sku[0].stock_num = "999";
                // self.form.model.sku[0].bag_price = "1";
                // self.form.model.sku[0].product_weight = "3";

                self.form.model.stock_num = "999"; //库存数量

                //菜品属性
                // self.form.model.product_attr = [{
                //     "attribute_name": "温度",
                //     "attribute_value": params.temperature
                // }];

                //加料
                // self.form.model.product_feed = [{"feed_name":"测试料","price":"1"}]; //菜品加料

                //菜品详情
                if (self.form.model.content.length == 0) {
                    self.form.model.content = "<p>" + params.description + "</p>";
                }


                //积分
                self.form.model.is_points_gift = 0;

                //初始销量
                self.form.model.sales_initial = "0";
                //限购数量
                self.form.model.limit_num = 0;
                //菜品排序
                self.form.model.product_sort = 100;

                //会员折扣
                self.form.model.is_enable_grade = 0; //是否开启会员折扣 1开启

                self.form.model.is_alone_grade = 0; // 0默认折扣  1单独设置折扣


                // self.$message({
                //     message: '补全成功',
                //     type: 'success'
                // });
            }).catch(error => {
                self.loading = false;
            });


        },
        //菜品卖点换一换
        onSellingPoint() {

            let self = this;

            self.selling_point_loading = true;

            PorductApi.dishInformation_featrue(self.form.model.product_name, {}, true).then(res => {
                self.selling_point_loading = false;
                console.log(res.data.response);

                //菜品卖点
                self.form.model.selling_point = res.data.response;

            }).catch(error => {
                self.selling_point_loading = false;
            });

        },
        // deleteImg
        deleteImg(index) {

            this.form.model.image.splice(index, 1);

        }, // openProductUpload
        openProductUpload() {

            this.isProductUpload = true;

        }, // returnProductImgsFunc
        returnProductImgsFunc(e) {

            if (e != null) {
                let imgs = this.form.model.image.concat(e);
                this.$set(this.form.model, 'image', imgs);
            }
            this.isProductUpload = false;

        },// addItem
        addItem() {

            this.form.model.ingredient.push({
                app_id: this.form.model.app_id,
                product_id: this.form.model.product_id,
                ingredient_id: 0,
                ingredient_name: '',
                sort: 1
            });


        }, // removeItem
        removeItem(index) {


            this.form.model.ingredient.splice(index, 1);


        }, // deleteItem
        deleteItem(_text) {


            const indexToRemove = this.form.model.ingredient.findIndex(item => item.ingredient_name === _text);

            if (indexToRemove !== -1) {
                this.form.model.ingredient.splice(indexToRemove, 1);
            }


        }
        // srcviewsproductstoreproductpartBasicvueMethodEnd

    },

    props: {
        // srcviewsproductstoreproductpartBasicvuePropsStart

        // srcviewsproductstoreproductpartBasicvuePropsEnd


    },
    async mounted() {
        // defaultLoad
        // defaultLoad
        // srcviewsproductstoreproductpartBasicvueMountedStart

        // srcviewsproductstoreproductpartBasicvueMountedEnd

    }
};
</script>

<style>
.srcviewsproductstoreproductpartBasicvuecssStart {}

.u7E3HKf {
    margin-right: 15px;
}

.draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.uiNJkJ4 {
    display: flex;
    justify-content: flex-start;
    width: auto;
}

.uBuIHG1 {
    display: flex;
    justify-content: center;
    width: inherit;
    flex: none;
    flex-direction: row;
    text-align: center;
    cursor: pointer;
    box-sizing: inherit;
    flex-wrap: nowrap;
}

.uFZHTog {
    display: flex;
    flex-direction: row;
}

.draggable-list .wrapper>span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
}

.draggable-list .item:hover .delete-btn {
    display: block;
}

.draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
}

.draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
}

.draggable-list .img-select i {
    color: #409eff;
}

.srcviewsproductstoreproductpartBasicvuecssEnd {}</style>



// WEBPACK FOOTER //
// src/views/buildstore/goods/store/product/part/Basic.vue